import { render, staticRenderFns } from "./DeadFilters.vue?vue&type=template&id=78783a77&scoped=true&"
import script from "./DeadFilters.vue?vue&type=script&lang=js&"
export * from "./DeadFilters.vue?vue&type=script&lang=js&"
import style0 from "./DeadFilters.vue?vue&type=style&index=0&id=78783a77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78783a77",
  null
  
)

export default component.exports